import { useState } from 'react'

const useToSetCharsLimit = () => {
  const [totalChars, setTotalChars] = useState(0)
  const updateCharsLength = (newChars) => {
    if (newChars !== undefined && newChars !== null) {
      // Handle both string and number inputs
      setTotalChars(typeof newChars === 'number' ? newChars : newChars.length)
    } else {
      setTotalChars(0)
    }
  }
  return { totalChars, updateCharsLength }
}

export default useToSetCharsLimit
